import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { Button, ButtonGroup, Collapse, Icon, Intent, Popover, Position } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { HTML, URL } from "src/libs/interfaces/layouts";
import { CommentInputForm, Likes } from "src/libs/useful";
import Bookmark from 'src/libs/useful/Bookmark';
import Shortcode from "src/libs/useful/shortcode";
import { __ } from "src/libs/utilities";
import { ILand } from "src/modules/pe-fest-module/data/interfaces";
import DateLabel from "../labels/DateLabel";
import EventTypeLabel from "../labels/EventTypeLabel";
import PlaceLabel from "../labels/PlaceLabel";

const {  Autoplay, Navigation, Pagination, Scrollbar, A11y, EffectFade  } =  require("swiper/modules")  
const {   Swiper, SwiperSlide } =  require("swiper/react")  

interface ILandContentProps {
    item : ILand
    onClose: () => void
    onOpenLogin?: () => void
    isNarrow?: boolean
}
const LandContent = (props: ILandContentProps) : JSX.Element => {
    const [isCommentOpen, setIsCommentOpen] = useState<boolean>(false)

    const onContentOpen = () => setIsCommentOpen(!isCommentOpen)
    const onSendComment = (comment: HTML) => {

    }
    const footerBtns: JSX.Element = <>
        <Collapse isOpen={isCommentOpen} transitionDuration={1000} className="anti-double-row-left">
            <CommentInputForm 
                item={props.item} 
                className="border-top border-secondary px-4 pb-2"
                onSend={ onSendComment }
                onAfterSend={onContentOpen}
                footer={<Button minimal onClick={onContentOpen}>{__("Close")}</Button>}
            />
        </Collapse>
        <div className="flex-centered border-top border-secondary">
            <ButtonGroup className="my-2">
                {/* <SubscribeForm dataType="Event" item={props.item} onOpenLogin={props.onOpenLogin} className="" /> */}
                {/* <EventRequestForm item={props.item} className=" " /> */}
                <Bookmark item={props.item}  className=" " />
                <Likes dataType="Land" item={props.item} className=" " />
                <Popover
                    interactionKind="hover" 
                    position={Position.TOP_RIGHT}
                    content={
                        <div className='p-2'> 
                            {__("Do comment")}
                        </div> 
                    }
                >
                    <Button minimal intent={Intent.NONE} large onClick={onContentOpen} className=" p-2" >
                        <Icon icon="comment" />
                    </Button>
                </Popover> 
            </ButtonGroup>
        </div>
    </> 
    return <div className="h-100"> 
        <div className=" h-100"> 
            <Land item={props.item} footer={footerBtns} isNarrow={props.isNarrow}/> 
        </div> 
    </div>
} 

export default LandContent

interface ILandProps {
    item: ILand
    footer: JSX.Element
    isNarrow?: boolean
}
export const Land = (props: ILandProps) : JSX.Element => { 
    const [thumbnail, setThumbnail] = useState( props.item.thumbnail || props.item.defaultThumbnail) 
    useEffect(()=> {
        setThumbnail( props.item.thumbnail || props.item.defaultThumbnail )    
    }, [props.item] )
    return <div className="h-100"> 
        <div className="row h-100">
            <div className="col-md-6 col-12 d-flex flex-column">
                <div 
                    className={` thumbnail ${!!props.item.images?.length ? "topos-event-thumbnail" : "topos-event-long-thumbnail" } `} 
                    style={{ backgroundImage: `url(${thumbnail})`}} 
                    onClick={() => setThumbnail( props.item.thumbnail || props.item.defaultThumbnail ) }
                />
                <GalleryLand item={props.item} setThumbnail={ setThumbnail } count={props.isNarrow ? 2 : 3} />
            </div>
            <div className="col-md-6 col-12 h-100 d-flex flex-column topos-dmap-long-content"> 
                <div className=" tab-container overflow-y-auto flex-grow-100">
                    <div className="lead-md pt-3">
                        {props.item.title}
                    </div>
                    <div className="descr text-force-contrast opacity_75 pb-3 ">
                        {props.item.description}
                    </div>
                    <EventTypeLabel item={props.item} className=" flex-wrap" />
                    <PlaceLabel places={props.item.places} className="mb-1  " />
                    <DateLabel item={props.item} className="mb-3  d-flex" />
                    <Shortcode content={props.item.post_content || props.item.content || ""} className="pr-3  pb-5" /> 
                </div>
                {props.footer}
            </div>
        </div> 
    </div>
} 

const GalleryLand = (props:any): JSX.Element => {
    return !!props.item.images?.length 
        ?
        <div className="gallery">
            <div className={ `gallery position-relative pagination-square-red ${props.galleryContainerClassName}` }>
                <Swiper
                    // install Swiper modules
                    modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y, EffectFade ] }   
                    loop={true} 
                    loopAddBlankSlides 
                    slidesPerView={ props.item.images?.length < props.count ? props.item.images?.length : props.count  } 
                    pagination={ true } 
                    
                    mousewheel
                    autoplay={  
                        {
                            delay: 20000,
                            disableOnInteraction: true,
                        } 
                    }
                >
                    {
                        props.item.images.map((image:URL, i: number) => {
                            return <SwiperSlide key={i}>
                                <GalleryImage image={image} key={image} setThumbnail={props.setThumbnail} />
                            </SwiperSlide>    
                        })
                    }
                </Swiper>
            </div>
            {
                props.item.images.map((image:URL) => {
                    return <GalleryImage image={image} key={image} setThumbnail={props.setThumbnail} />
                }) 
            }
        </div>
        :
        <></>
}

const GalleryImage = (props:any) :JSX.Element => {
    return <div 
        className=" gallery thumbnail w-100" 
        style={{ backgroundImage: `url(${ props.image })` }}
        onClick={() => props.setThumbnail( props.image )}
    />
}